<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>상품 상세 정보 조회</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">상품 리스트</button>
        </div>
        <div>
          <button class="btn btn-140" @click="deleteProduct">
            <span v-if="!processing" class="process">상품 삭제</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button class="btn btn-140" @click="updateProduct">상품 수정</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">상품 ID</td>
            <!-- TODO <td>{{ product.productAlias }}</td> -->
            <td>{{ product.productID }}</td>
          </tr>
          <tr>
            <td class="header">상품 영문 이름</td>
            <td>{{ product.productEngName }}</td>
          </tr>
          <tr>
            <td class="header">공급 가격</td>
            <td>{{ Number(product.supplyPrice).toLocaleString() }}</td>
          </tr>
          <tr>
            <td class="header">유통 시간(시)</td>
            <td>{{ product.expirePeriod }}</td>
          </tr>
          <tr>
            <td class="header">소유 회사</td>
            <td>{{ product.companyName }}</td>
          </tr>
          <tr>
            <td class="header">바코드</td>
            <td>{{ product.barcode }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">상품 이름</td>
            <td>{{ product.productName }}</td>
          </tr>
          <tr>
            <td class="header">상품 종류</td>
            <td>{{ product.productType }}</td>
          </tr>
          <tr>
            <td class="header">판매 가격</td>
            <td>{{ Number(product.salePrice).toLocaleString() }}</td>
          </tr>
          <tr>
            <td class="header">무게(g)</td>
            <td>{{ product.weight }}</td>
          </tr>
          <tr>
            <td class="header">소유 부서</td>
            <td>{{ product.divisionName }}</td>
          </tr>
          <tr>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">상품 사진</td>
            <td>
              <div>
                <ProductThumbnail :productThumbnail="prodThumbnail"></ProductThumbnail>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div v-else-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">상품 ID</td>
            <!-- TODO <td><input type="input" v-model="editProduct.productAlias" tabindex="1"/></td> -->
            <td> {{ editProduct.productID }} </td>
          </tr>
          <tr>
            <td class="header">상품 영문 이름</td>
            <td><input type="input" v-model="editProduct.productEngName" tabindex="3"/></td>
          </tr>
          <tr>
            <td class="header">공급 가격</td>
            <td><input type="input" v-model="editProduct.supplyPrice" tabindex="5"/></td>
          </tr>
          <tr>
            <td class="header">유통 시간(시)</td>
            <td><input type="input" v-model="editProduct.expirePeriod" tabindex="7"/></td>
          </tr>
          <tr>
            <td class="header">소유 회사</td>
            <td>
              <select v-model="editProduct.companyID" @change="selectCompany(editProduct.companyID)" tabindex="9">
                <option v-for="item in companyList" :key="item.companyID" :value="item.companyID">
                  {{ item.companyName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">바코드</td>
            <td><input type="input" v-model="editProduct.barcode" tabindex="11"/></td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">상품 이름</td>
            <td><input type="input" v-model="editProduct.productName" tabindex="2"/></td>
          </tr>
          <tr>
            <td class="header">상품 종류</td>
            <td><input type="input" v-model="editProduct.productType" tabindex="4"/></td>
          </tr>
          <tr>
            <td class="header">판매 가격</td>
            <td><input type="input" v-model="editProduct.salePrice" tabindex="6"/></td>
          </tr>
          <tr>
            <td class="header">무게(g)</td>
            <td><input type="input" v-model="editProduct.weight" tabindex="8"/></td>
          </tr>
          <tr>
            <td class="header">소유 부서</td>
            <td>
              <select v-model="editProduct.divisionID" tabindex="10">
                <option v-for="item in divisionList" :key="item.divisionID" :value="item.divisionID">
                  {{ item.divisionName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">상품 사진</td>
            <td>
              <div>
                <ProductThumbnail :productThumbnail="prodThumbnail" editable @edited:thumbnail="editThumbnail"></ProductThumbnail>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-btn center">
        <button
          class="btn btn-140 btn-blue-line"
          @click="excuteUpdate"
        >
          <span v-if="!processing" class="process">수정</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ProductThumbnail from '@/components/product/ProductThumbnail';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  components: {
    ProductThumbnail,
    ButtonLoading,
  },
  props: [
    'product',
  ],
  data: () => ({
    detailType: 'view',
    companyList: [],
    divisionList: [],
    editProduct: {
      productID: null,
      productName: null,
      productEngName: null,
      productAlias: null,
      productType: null,
      supplyPrice: null,
      salePrice: null,
      weight: null,
      expirePeriod: null,
      barcode: null,
      companyID: null,
      divisionID: null,
    },
    thumbnail: null,
    prodThumbnail: null,
    processing: false,
  }),
  async created() {
    this.fetchCompanyList();
    this.fetchProductThumbnail();
  },
  methods: {
    async updateProduct() {
      this.editProduct.productID = this.product.productID;
      this.editProduct.productName = this.product.productName;
      this.editProduct.productEngName = this.product.productEngName;
      this.editProduct.productAlias = this.product.productAlias;
      this.editProduct.productType = this.product.productType;
      this.editProduct.supplyPrice = this.product.supplyPrice;
      this.editProduct.salePrice = this.product.salePrice;
      this.editProduct.weight = this.product.weight;
      this.editProduct.expirePeriod = this.product.expirePeriod;
      this.editProduct.barcode = this.product.barcode;
      this.editProduct.companyID = this.product.companyID;
      this.editProduct.divisionID = this.product.divisionID;

      this.detailType = 'edit';
      await this.selectCompany(this.product.companyID);
      await this.selectDivision(this.product.divisionID);
    },
    async fetchCompanyList() {
      try {
        const listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          throw new Error(`Response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${list.data.resultCode}"`);
        }

        const companyList = [];
        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];
          if (p.scope === 3) {
            companyList.push(p);
          }
        }
        this.companyList = companyList;
      } catch (e) {
        console.error(e);
      }
    },
    async fetchProductThumbnail() {
      const thumbnailUrl = `${Configuration.value('CSTORAGE_ADDRESS',
      )}/api/v1/cstorage/${this.product.productID}/thumbnail`;

      const thumbnail = await this.$http.get(thumbnailUrl, {
        headers: {
          Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
        },
      });

      if (thumbnail.status === 200) {
        this.prodThumbnail = thumbnail.data;
      }
    },
    async selectCompany(companyID) {
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${companyID}?withDivisions=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        this.divisionList = result.data.company.divisions;
      } catch (e) {
        console.error(e);
      }
    },
    async selectDivision(divisionID, type) {
      if (!divisionID) {
        return;
      }
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/${divisionID}?withUsers=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        if (type === 1) {
          this.userList = result.data.division.users;
        } else {
          this.operatorUserList = result.data.division.users;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/product/${this.product.productID}`;

        this.editProduct.supplyPrice = parseInt(this.editProduct.supplyPrice, 10);
        this.editProduct.supplyPrice = parseInt(this.editProduct.supplyPrice, 10);
        this.editProduct.salePrice = parseInt(this.editProduct.salePrice, 10);
        this.editProduct.weight = parseFloat(this.editProduct.weight);
        this.editProduct.expirePeriod = parseInt(this.editProduct.expirePeriod, 10);

        const param = this.editProduct;
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        if (this.thumbnail !== null) {
          const uploadUrl = `${Configuration.value('CSTORAGE_ADDRESS',
          )}/api/v1/cstorage/${this.product.productID}/thumbnail`;

          const formData = new FormData();
          formData.append('thumbnail', this.thumbnail);

          this.$http.post(uploadUrl,
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
                'Content-Type': 'multipart/form-data',
              },
            },
          );
        }

        const company = {
          id: this.product.companyID,
          name: this.product.companyName,
          alias: this.product.companyAlias,
        };
        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      this.detailType = 'view';
    },
    async deleteProduct() {
      this.processing = true;
      const product = await this.$getProduct(this.product.productID, true);
      if (!product) {
        alert('존재하지 않는 상품입니다.');
        this.processing = false;
        return;
      } else if (product.dependence) {
        alert('판매중인 상품은 삭제할 수 없습니다.\n"재고 관리"를 확인해 주세요.');
        this.processing = false;
        return;
      }

      if (!confirm('정말 삭제하시겠습니까?')) {
        this.processing = false;
        return;
      }

      try {
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/product/${this.product.productID}`;

        const createResult = await this.$http.delete(url,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.product.companyID,
          name: this.product.companyName,
        };
        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        if (e.response.status === 403) {
          alert('사용중 입니다.');
        } else {
          console.error(e);
        }
        this.processing = false;
      }
    },
    goList() {
      const company = {
        id: this.product.companyID,
        name: this.product.companyName,
        alias: this.product.companyAlias,
      };
      this.$emit('refreshList', company, 'company');
    },
    editThumbnail(thumbnail) {
      this.thumbnail = thumbnail;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetail.vue